﻿"use strict";

const Modal = {
  init: function() {
    this.body = document.getElementsByTagName("body")[0];
    this.buttons = document.querySelectorAll(".init-modal");

    this.events();
  },

  events: function() {
    var self = this;

    this.onClick();

    this.body.onkeydown = function(e) {
      e.keyCode === 27 ? self.onClose() : false;
    };

    this.body.addEventListener("click", function(e) {
      e.target === self.overlay ? self.onClose() : false;
    });
  },

  onClick: function() {
    var self = this;

    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].addEventListener("click", function(e) {
        self.initOverlay(e);
      });
    }
  },

  initOverlay: function(e) {
    var target = e.currentTarget;

    this.overlay = document.createElement("div");
    this.overlay.classList.add("overlay");

    this.body.append(this.overlay);
    this.body.classList.add("body--lock");

    this.initModal(target);
  },

  initModal: function(target) {
    var self = this;

    this.modal = document.createElement("div");
    this.modal.classList.add("modal");

    this.close = document.createElement("button");
    this.close.classList.add("button");
    this.close.classList.add("overlay--close");
    this.close.innerHTML = '<img src="/img/close.svg" />';

    this.close.addEventListener("click", function() {
      self.onClose();
    });

    this.overlay.appendChild(this.modal);
    this.modal.appendChild(this.close);

    this.populateModal(target);
  },

  onClose: function() {
    if (!this.overlay || this.body.classList.contains("body--lock") === false) {
      return;
    }

    this.overlay.parentNode.removeChild(this.overlay);
    this.body.classList.remove("body--lock");
  },

  populateModal: function(target) {
    this.container = document.createElement("div");
    this.container.classList.add("modal__container");

    this.iframe = document.createElement("iframe");
    this.iframe.src =
      "https://www.youtube.com/embed/" +
      target.getAttribute("data-id") +
      "?autoplay=1&rel=0";

    this.modal.appendChild(this.iframe);
  }
};

module.exports = Modal.init();
